import React from 'react'
import { InstallType, useIsEligibleForInstall } from '../../../../lib/hooks/install-eligibility'
import { ButtonCtaProps } from '../../../ui-lib/button'
import { LlamaDownloadButtonBase, LlamaUnsupportedOSButton } from './base'

export type MacDownloadButtonProps = Omit<ButtonCtaProps, 'onClick'>

export const MacDownloadButton: React.FC<MacDownloadButtonProps> = (props) => {
  const isEligible = useIsEligibleForInstall(InstallType.Mac)

  return isEligible ? <LlamaDownloadButtonBase {...props} /> : <LlamaUnsupportedOSButton {...props} />
}
